// some issues with NLPJS stopword dictionaries, so providing them for Danish and German manually:

// Thank you: https://gist.github.com/berteltorp/0cf8a0c7afea7f25ed754f24cfc2467b
export const stopwordDictDa = {
  ad: true,
  af: true,
  akkurat: true,
  al: true,
  aldrig: true,
  alene: true,
  alle: true,
  allerede: true,
  alligevel: true,
  alt: true,
  altid: true,
  altsaa: true,
  anden: true,
  andet: true,
  andre: true,
  art: true,
  at: true,
  bag: true,
  bare: true,
  begge: true,
  "bl.a.": true,
  blandt: true,
  blev: true,
  blive: true,
  bliver: true,
  blot: true,
  bringe: true,
  brug: true,
  burde: true,
  baade: true,
  boer: true,
  "ca.": true,
  da: true,
  dag: true,
  de: true,
  del: true,
  dem: true,
  den: true,
  denne: true,
  dens: true,
  der: true,
  derefter: true,
  deres: true,
  derfor: true,
  derfra: true,
  deri: true,
  dermed: true,
  derpaa: true,
  derved: true,
  des: true,
  desto: true,
  det: true,
  dets: true,
  dette: true,
  dig: true,
  din: true,
  dine: true,
  disse: true,
  dit: true,
  dog: true,
  du: true,
  deer: true,
  deet: true,
  efter: true,
  egen: true,
  ej: true,
  eller: true,
  ellers: true,
  en: true,
  end: true,
  endelig: true,
  endnu: true,
  ene: true,
  eneste: true,
  enhver: true,
  ens: true,
  enten: true,
  er: true,
  et: true,
  "f.eks.": true,
  faktisk: true,
  far: true,
  fat: true,
  fem: true,
  fik: true,
  find: true,
  finde: true,
  fire: true,
  flere: true,
  flest: true,
  fleste: true,
  for: true,
  foran: true,
  fordi: true,
  forrige: true,
  fortsat: true,
  fra: true,
  fx: true,
  faa: true,
  faar: true,
  foelg: true,
  foelge: true,
  foelger: true,
  foer: true,
  foerst: true,
  foerste: true,
  gang: true,
  gennem: true,
  gerne: true,
  gid: true,
  giv: true,
  giver: true,
  givet: true,
  gjorde: true,
  gjort: true,
  god: true,
  godt: true,
  gaa: true,
  gaar: true,
  goer: true,
  goere: true,
  goerende: true,
  ha: true,
  haft: true,
  ham: true,
  han: true,
  hans: true,
  har: true,
  havde: true,
  have: true,
  hej: true,
  hel: true,
  heldigvis: true,
  hele: true,
  heller: true,
  helst: true,
  helt: true,
  hen: true,
  hende: true,
  hendes: true,
  henover: true,
  her: true,
  herefter: true,
  heri: true,
  hermed: true,
  herpaa: true,
  holder: true,
  hos: true,
  hun: true,
  hvad: true,
  hvem: true,
  hver: true,
  hvert: true,
  hvilke: true,
  hvilken: true,
  hvilkes: true,
  hvis: true,
  hvor: true,
  hvordan: true,
  hvorefter: true,
  hvorfor: true,
  hvorfra: true,
  hvorhen: true,
  hvori: true,
  hvorimod: true,
  hvornaar: true,
  hvorved: true,
  hoer: true,
  hoerer: true,
  hoert: true,
  hoerte: true,
  i: true,
  igen: true,
  igennem: true,
  ikke: true,
  imellem: true,
  imens: true,
  imod: true,
  ind: true,
  indtil: true,
  ingen: true,
  intet: true,
  isaer: true,
  ioevrigt: true,
  ja: true,
  jeg: true,
  jer: true,
  jeres: true,
  jo: true,
  kan: true,
  kom: true,
  komme: true,
  kommer: true,
  kommet: true,
  kun: true,
  kunne: true,
  lad: true,
  langs: true,
  lav: true,
  lave: true,
  lavet: true,
  lidt: true,
  lig: true,
  lige: true,
  ligesom: true,
  ligesaa: true,
  ligge: true,
  ligger: true,
  lille: true,
  lissom: true,
  laengere: true,
  man: true,
  mand: true,
  mange: true,
  med: true,
  meget: true,
  mellem: true,
  men: true,
  mens: true,
  mere: true,
  mest: true,
  mig: true,
  min: true,
  mindre: true,
  mindst: true,
  mine: true,
  mit: true,
  mod: true,
  maa: true,
  maaske: true,
  maatte: true,
  maattet: true,
  ned: true,
  nej: true,
  nemlig: true,
  netop: true,
  ni: true,
  nogen: true,
  nogensinde: true,
  noget: true,
  nogle: true,
  nok: true,
  nu: true,
  ny: true,
  nye: true,
  nyt: true,
  naa: true,
  naar: true,
  naer: true,
  naeste: true,
  naesten: true,
  og: true,
  ogsaa: true,
  okay: true,
  om: true,
  omkring: true,
  op: true,
  os: true,
  otte: true,
  over: true,
  overalt: true,
  overhovedet: true,
  "pga.": true,
  paa: true,
  ret: true,
  rigt: true,
  ro: true,
  rundt: true,
  sagt: true,
  samme: true,
  sammen: true,
  se: true,
  seks: true,
  selv: true,
  selvom: true,
  senere: true,
  ser: true,
  ses: true,
  set: true,
  siden: true,
  sig: true,
  sige: true,
  siger: true,
  simpelthen: true,
  sin: true,
  sine: true,
  sit: true,
  skal: true,
  skam: true,
  ske: true,
  sker: true,
  skulle: true,
  smaa: true,
  smaat: true,
  snart: true,
  som: true,
  stadig: true,
  stor: true,
  store: true,
  stort: true,
  synes: true,
  syntes: true,
  syv: true,
  saa: true,
  saadan: true,
  saaledes: true,
  saamaend: true,
  saavel: true,
  saerlig: true,
  tag: true,
  tage: true,
  temmelig: true,
  thi: true,
  ti: true,
  tidligere: true,
  til: true,
  tilbage: true,
  tit: true,
  to: true,
  tre: true,
  taet: true,
  ud: true,
  ude: true,
  uden: true,
  udover: true,
  under: true,
  undtagen: true,
  var: true,
  ved: true,
  vel: true,
  vi: true,
  via: true,
  videre: true,
  vil: true,
  ville: true,
  vis: true,
  vise: true,
  vist: true,
  vor: true,
  vore: true,
  vores: true,
  vort: true,
  vaer: true,
  vaere: true,
  vaeret: true,
  veed: true,
  aar: true,
  aars: true,
  een: true,
  eet: true,
  oevrigt: true,
  altså: true,
  både: true,
  bør: true,
  derpå: true,
  dér: true,
  dét: true,
  få: true,
  får: true,
  følg: true,
  følge: true,
  følger: true,
  før: true,
  først: true,
  første: true,
  gå: true,
  går: true,
  gør: true,
  gøre: true,
  gørende: true,
  herpå: true,
  hvornår: true,
  hør: true,
  hører: true,
  hørt: true,
  hørte: true,
  især: true,
  iøvrigt: true,
  ligeså: true,
  længere: true,
  må: true,
  måske: true,
  måtte: true,
  måttet: true,
  nå: true,
  når: true,
  nær: true,
  næste: true,
  næsten: true,
  også: true,
  på: true,
  små: true,
  småt: true,
  så: true,
  sådan: true,
  således: true,
  såmænd: true,
  såvel: true,
  særlig: true,
  tæt: true,
  vær: true,
  være: true,
  været: true,
  véd: true,
  år: true,
  års: true,
  én: true,
  ét: true,
  øvrigt: true,
};

// Thank you: https://github.com/solariz/german_stopwords/blob/master/german_stopwords_plain.txt
export const stopwordDictDe = {
  ab: true,
  aber: true,
  alle: true,
  allein: true,
  allem: true,
  allen: true,
  aller: true,
  allerdings: true,
  allerlei: true,
  alles: true,
  allmählich: true,
  allzu: true,
  als: true,
  alsbald: true,
  also: true,
  am: true,
  an: true,
  and: true,
  ander: true,
  andere: true,
  anderem: true,
  anderen: true,
  anderer: true,
  andererseits: true,
  anderes: true,
  anderm: true,
  andern: true,
  andernfalls: true,
  anders: true,
  anstatt: true,
  auch: true,
  auf: true,
  aus: true,
  ausgenommen: true,
  ausser: true,
  ausserdem: true,
  außer: true,
  außerdem: true,
  außerhalb: true,
  bald: true,
  bei: true,
  beide: true,
  beiden: true,
  beiderlei: true,
  beides: true,
  beim: true,
  beinahe: true,
  bereits: true,
  besonders: true,
  besser: true,
  beträchtlich: true,
  bevor: true,
  bezüglich: true,
  bin: true,
  bis: true,
  bisher: true,
  bislang: true,
  bist: true,
  bloß: true,
  "bsp.": true,
  bzw: true,
  ca: true,
  "ca.": true,
  content: true,
  da: true,
  dabei: true,
  dadurch: true,
  dafür: true,
  dagegen: true,
  daher: true,
  dahin: true,
  damals: true,
  damit: true,
  danach: true,
  daneben: true,
  dann: true,
  daran: true,
  darauf: true,
  daraus: true,
  darin: true,
  darum: true,
  darunter: true,
  darüber: true,
  darüberhinaus: true,
  das: true,
  dass: true,
  dasselbe: true,
  davon: true,
  davor: true,
  dazu: true,
  daß: true,
  dein: true,
  deine: true,
  deinem: true,
  deinen: true,
  deiner: true,
  deines: true,
  dem: true,
  demnach: true,
  demselben: true,
  den: true,
  denen: true,
  denn: true,
  dennoch: true,
  denselben: true,
  der: true,
  derart: true,
  derartig: true,
  derem: true,
  deren: true,
  derer: true,
  derjenige: true,
  derjenigen: true,
  derselbe: true,
  derselben: true,
  derzeit: true,
  des: true,
  deshalb: true,
  desselben: true,
  dessen: true,
  desto: true,
  deswegen: true,
  dich: true,
  die: true,
  diejenige: true,
  dies: true,
  diese: true,
  dieselbe: true,
  dieselben: true,
  diesem: true,
  diesen: true,
  dieser: true,
  dieses: true,
  diesseits: true,
  dir: true,
  direkt: true,
  direkte: true,
  direkten: true,
  direkter: true,
  doch: true,
  dort: true,
  dorther: true,
  dorthin: true,
  drauf: true,
  drin: true,
  drunter: true,
  drüber: true,
  du: true,
  dunklen: true,
  durch: true,
  durchaus: true,
  eben: true,
  ebenfalls: true,
  ebenso: true,
  eher: true,
  eigenen: true,
  eigenes: true,
  eigentlich: true,
  ein: true,
  eine: true,
  einem: true,
  einen: true,
  einer: true,
  einerseits: true,
  eines: true,
  einfach: true,
  einführen: true,
  einführte: true,
  einführten: true,
  eingesetzt: true,
  einig: true,
  einige: true,
  einigem: true,
  einigen: true,
  einiger: true,
  einigermaßen: true,
  einiges: true,
  einmal: true,
  eins: true,
  einseitig: true,
  einseitige: true,
  einseitigen: true,
  einseitiger: true,
  einst: true,
  einstmals: true,
  einzig: true,
  entsprechend: true,
  entweder: true,
  er: true,
  erst: true,
  es: true,
  etc: true,
  etliche: true,
  etwa: true,
  etwas: true,
  euch: true,
  euer: true,
  eure: true,
  eurem: true,
  euren: true,
  eurer: true,
  eures: true,
  falls: true,
  fast: true,
  ferner: true,
  folgende: true,
  folgenden: true,
  folgender: true,
  folgendes: true,
  folglich: true,
  fuer: true,
  für: true,
  gab: true,
  ganze: true,
  ganzem: true,
  ganzen: true,
  ganzer: true,
  ganzes: true,
  gar: true,
  gegen: true,
  gemäss: true,
  ggf: true,
  gleich: true,
  gleichwohl: true,
  gleichzeitig: true,
  glücklicherweise: true,
  gänzlich: true,
  hab: true,
  habe: true,
  haben: true,
  haette: true,
  hast: true,
  hat: true,
  hatte: true,
  hatten: true,
  hattest: true,
  hattet: true,
  heraus: true,
  herein: true,
  hier: true,
  hiermit: true,
  hiesige: true,
  hin: true,
  hinein: true,
  hinten: true,
  hinter: true,
  hinterher: true,
  http: true,
  hätt: true,
  hätte: true,
  hätten: true,
  höchstens: true,
  ich: true,
  igitt: true,
  ihm: true,
  ihn: true,
  ihnen: true,
  ihr: true,
  ihre: true,
  ihrem: true,
  ihren: true,
  ihrer: true,
  ihres: true,
  im: true,
  immer: true,
  immerhin: true,
  in: true,
  indem: true,
  indessen: true,
  infolge: true,
  innen: true,
  innerhalb: true,
  ins: true,
  insofern: true,
  inzwischen: true,
  irgend: true,
  irgendeine: true,
  irgendwas: true,
  irgendwen: true,
  irgendwer: true,
  irgendwie: true,
  irgendwo: true,
  ist: true,
  ja: true,
  je: true,
  jed: true,
  jede: true,
  jedem: true,
  jeden: true,
  jedenfalls: true,
  jeder: true,
  jederlei: true,
  jedes: true,
  jedoch: true,
  jemand: true,
  jene: true,
  jenem: true,
  jenen: true,
  jener: true,
  jenes: true,
  jenseits: true,
  jetzt: true,
  jährig: true,
  jährige: true,
  jährigen: true,
  jähriges: true,
  kam: true,
  kann: true,
  kannst: true,
  kaum: true,
  kein: true,
  keine: true,
  keinem: true,
  keinen: true,
  keiner: true,
  keinerlei: true,
  keines: true,
  keineswegs: true,
  klar: true,
  klare: true,
  klaren: true,
  klares: true,
  klein: true,
  kleinen: true,
  kleiner: true,
  kleines: true,
  koennen: true,
  koennt: true,
  koennte: true,
  koennten: true,
  komme: true,
  kommen: true,
  kommt: true,
  konkret: true,
  konkrete: true,
  konkreten: true,
  konkreter: true,
  konkretes: true,
  können: true,
  könnt: true,
  künftig: true,
  leider: true,
  machen: true,
  man: true,
  manche: true,
  manchem: true,
  manchen: true,
  mancher: true,
  mancherorts: true,
  manches: true,
  manchmal: true,
  mehr: true,
  mehrere: true,
  mein: true,
  meine: true,
  meinem: true,
  meinen: true,
  meiner: true,
  meines: true,
  mich: true,
  mir: true,
  mit: true,
  mithin: true,
  muessen: true,
  muesst: true,
  muesste: true,
  muss: true,
  musst: true,
  musste: true,
  mussten: true,
  muß: true,
  mußt: true,
  müssen: true,
  müsste: true,
  müssten: true,
  müßt: true,
  müßte: true,
  nach: true,
  nachdem: true,
  nachher: true,
  nachhinein: true,
  nahm: true,
  natürlich: true,
  neben: true,
  nebenan: true,
  nehmen: true,
  nein: true,
  nicht: true,
  nichts: true,
  nie: true,
  niemals: true,
  niemand: true,
  nirgends: true,
  nirgendwo: true,
  noch: true,
  nun: true,
  nur: true,
  nächste: true,
  nämlich: true,
  nötigenfalls: true,
  ob: true,
  oben: true,
  oberhalb: true,
  obgleich: true,
  obschon: true,
  obwohl: true,
  oder: true,
  oft: true,
  per: true,
  plötzlich: true,
  schließlich: true,
  schon: true,
  sehr: true,
  sehrwohl: true,
  seid: true,
  sein: true,
  seine: true,
  seinem: true,
  seinen: true,
  seiner: true,
  seines: true,
  seit: true,
  seitdem: true,
  seither: true,
  selber: true,
  selbst: true,
  sich: true,
  sicher: true,
  sicherlich: true,
  sie: true,
  sind: true,
  so: true,
  sobald: true,
  sodass: true,
  sodaß: true,
  soeben: true,
  sofern: true,
  sofort: true,
  sogar: true,
  solange: true,
  solch: true,
  solche: true,
  solchem: true,
  solchen: true,
  solcher: true,
  solches: true,
  soll: true,
  sollen: true,
  sollst: true,
  sollt: true,
  sollte: true,
  sollten: true,
  solltest: true,
  somit: true,
  sondern: true,
  sonst: true,
  sonstwo: true,
  sooft: true,
  soviel: true,
  soweit: true,
  sowie: true,
  sowohl: true,
  tatsächlich: true,
  tatsächlichen: true,
  tatsächlicher: true,
  tatsächliches: true,
  trotzdem: true,
  ueber: true,
  um: true,
  umso: true,
  unbedingt: true,
  und: true,
  unmöglich: true,
  unmögliche: true,
  unmöglichen: true,
  unmöglicher: true,
  uns: true,
  unser: true,
  unsere: true,
  unserem: true,
  unseren: true,
  unserer: true,
  unseres: true,
  unter: true,
  usw: true,
  viel: true,
  viele: true,
  vielen: true,
  vieler: true,
  vieles: true,
  vielleicht: true,
  vielmals: true,
  vom: true,
  von: true,
  vor: true,
  voran: true,
  vorher: true,
  vorüber: true,
  völlig: true,
  wann: true,
  war: true,
  waren: true,
  warst: true,
  warum: true,
  was: true,
  weder: true,
  weil: true,
  weiter: true,
  weitere: true,
  weiterem: true,
  weiteren: true,
  weiterer: true,
  weiteres: true,
  weiterhin: true,
  weiß: true,
  welche: true,
  welchem: true,
  welchen: true,
  welcher: true,
  welches: true,
  wem: true,
  wen: true,
  wenig: true,
  wenige: true,
  weniger: true,
  wenigstens: true,
  wenn: true,
  wenngleich: true,
  wer: true,
  werde: true,
  werden: true,
  werdet: true,
  weshalb: true,
  wessen: true,
  wichtig: true,
  wie: true,
  wieder: true,
  wieso: true,
  wieviel: true,
  wiewohl: true,
  will: true,
  willst: true,
  wir: true,
  wird: true,
  wirklich: true,
  wirst: true,
  wo: true,
  wodurch: true,
  wogegen: true,
  woher: true,
  wohin: true,
  wohingegen: true,
  wohl: true,
  wohlweislich: true,
  womit: true,
  woraufhin: true,
  woraus: true,
  worin: true,
  wurde: true,
  wurden: true,
  während: true,
  währenddessen: true,
  wär: true,
  wäre: true,
  wären: true,
  würde: true,
  würden: true,
  "z.B.": true,
  zB: true,
  zahlreich: true,
  zeitweise: true,
  zu: true,
  zudem: true,
  zuerst: true,
  zufolge: true,
  zugleich: true,
  zuletzt: true,
  zum: true,
  zumal: true,
  zur: true,
  zurück: true,
  zusammen: true,
  zuviel: true,
  zwar: true,
  zwischen: true,
  ähnlich: true,
  übel: true,
  über: true,
  überall: true,
  überallhin: true,
  überdies: true,
  übermorgen: true,
  übrig: true,
  übrigens: true,
};
